var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0826 2.07812H4.08784C3.35194 2.07812 2.75537 2.67469 2.75537 3.41059V14.0703C2.75537 14.8062 3.35194 15.4028 4.08784 15.4028H12.0826C12.8185 15.4028 13.4151 14.8062 13.4151 14.0703V3.41059C13.4151 2.67469 12.8185 2.07812 12.0826 2.07812Z",
    stroke: "#1E1E1E",
    strokeOpacity: 0.4,
    strokeWidth: 1.3325,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08643 15.4032V12.7383H10.0838V15.4032",
    stroke: "#1E1E1E",
    strokeOpacity: 0.4,
    strokeWidth: 1.3325,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42041 4.74316H5.42707H5.42041Z",
    fill: "#16A34A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42041 4.74316H5.42707",
    stroke: "#1E1E1E",
    strokeOpacity: 0.4,
    strokeWidth: 1.3325,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7505 4.74316H10.7572H10.7505Z",
    fill: "#16A34A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7505 4.74316H10.7572",
    stroke: "#1E1E1E",
    strokeOpacity: 0.4,
    strokeWidth: 1.3325,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08496 4.74316H8.09162H8.08496Z",
    fill: "#16A34A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08496 4.74316H8.09162",
    stroke: "#1E1E1E",
    strokeOpacity: 0.4,
    strokeWidth: 1.3325,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08496 7.40771H8.09162H8.08496Z",
    fill: "#16A34A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08496 7.40771H8.09162",
    stroke: "#1E1E1E",
    strokeOpacity: 0.4,
    strokeWidth: 1.3325,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08496 10.0728H8.09162",
    stroke: "#1E1E1E",
    strokeOpacity: 0.4,
    strokeWidth: 1.3325,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7505 7.4082H10.7572H10.7505Z",
    fill: "#16A34A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7505 7.4082H10.7572",
    stroke: "#1E1E1E",
    strokeOpacity: 0.4,
    strokeWidth: 1.3325,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7505 10.0732H10.7572H10.7505Z",
    fill: "#16A34A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7505 10.0732H10.7572",
    stroke: "#1E1E1E",
    strokeOpacity: 0.4,
    strokeWidth: 1.3325,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42041 7.40771H5.42707H5.42041Z",
    fill: "#16A34A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42041 7.40771H5.42707",
    stroke: "#1E1E1E",
    strokeOpacity: 0.4,
    strokeWidth: 1.3325,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42041 10.0728H5.42707H5.42041Z",
    fill: "#16A34A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42041 10.0728H5.42707",
    stroke: "#1E1E1E",
    strokeOpacity: 0.4,
    strokeWidth: 1.3325,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.41f27c6baebc5cb593a1887d097da032.svg";
export { ForwardRef as ReactComponent };